/* eslint-disable */
// Dynamic Loading Modules

// Admin Views
const ReportesInspirados = resolve => { require.ensure(['../views/reportes/ReportesInspirados.vue'], () => { resolve(require('../views/reportes/ReportesInspirados.vue')); }); };
const UploadCSVMoodle = resolve => { require.ensure(['../views/admin/UploadCSVMoodle.vue'], () => { resolve(require('../views/admin/UploadCSVMoodle.vue')); }); };
const UploadCSVCargue = resolve => { require.ensure(['../views/admin/UploadCSVCargue.vue'], () => { resolve(require('../views/admin/UploadCSVCargue.vue')); }); };

// Views
const Dashboard = resolve => { require.ensure(['../views/dashboard'], ()=>{ resolve(require('../views/dashboard')); }); };
// HEAD
const ReportesInspiradores = resolve => { require.ensure(['../views/reportes/ReportesInspiradores.vue'], () => { resolve(require('../views/reportes/ReportesInspiradores.vue')); }); };
const ReportesSabana = resolve => { require.ensure(['../views/reportes/ReportesSabana.vue'], () => { resolve(require('../views/reportes/ReportesSabana.vue')); }); };
const ReportesMinTic = resolve => { require.ensure(['../views/reportes/ReportesMinTic.vue'], () => { resolve(require('../views/reportes/ReportesMinTic.vue')); }); };
const AdminInspiradores = resolve => { require.ensure(['../views/admin/AdminInspiradores.vue'], ()=>{ resolve(require('../views/admin/AdminInspiradores.vue')); }); };
// UI Components

// origin
const Documentos = resolve => { require.ensure(['../views/documentos/Documentos.vue'], () => { resolve(require('../views/documentos/Documentos.vue')); }); };
const SubirDocumento = resolve => { require.ensure(['../views/documentos/SubirDocumento.vue'], () => { resolve(require('../views/documentos/SubirDocumento.vue')); }); };

// Inspiradores
// const CrearInspirador = resolve => { require.ensure(['../views/inspiradores/Crear.vue'], ()=>{ resolve(require('../views/inspiradores/Crear.vue')); }); };
const EditarInspirador = resolve => { require.ensure(['../views/inspiradores/Editar.vue'], () => { resolve(require('../views/inspiradores/Editar.vue')); }); };
const VerInspirador = resolve => { require.ensure(['../views/inspiradores/VerInspirador.vue'], () => { resolve(require('../views/inspiradores/VerInspirador.vue')); }); };
const Inspiradores = resolve => { require.ensure(['../views/inspiradores/Inspiradores.vue'], ()=>{ resolve(require('../views/inspiradores/Inspiradores.vue')); }); };

// Inspirados
const VerInspirado = resolve => { require.ensure(['../views/inspirados/VerInspirado.vue'], () => { resolve(require('../views/inspirados/VerInspirado.vue')); }); };
const CrearInspirado = resolve => { require.ensure(['../views/inspirados/Crear.vue'], ()=>{ resolve(require('../views/inspirados/Crear.vue')); }); };
const EditarInspirado = resolve => { require.ensure(['../views/inspirados/Editar.vue'], () => { resolve(require('../views/inspirados/Editar.vue')); }); };
const Inspirados = resolve => { require.ensure(['../views/inspirados/Inspirados.vue'], ()=>{ resolve(require('../views/inspirados/Inspirados.vue')); }); };
const CrearHistoria = resolve => { require.ensure(['../views/inspirados/historias/CrearHistoria.vue'], () => { resolve(require('../views/inspirados/historias/CrearHistoria.vue')); }); };

//Maps
const GoogleMapsPage = resolve => { require.ensure(['../components/maps/google-maps/GoogleMapsPage.vue'], ()=>{ resolve(require('../components/maps/google-maps/GoogleMapsPage.vue')); }); };
const LeafletMapsPage = resolve => { require.ensure(['../components/maps/leaflet-maps/LeafletMapsPage.vue'], ()=>{ resolve(require('../components/maps/leaflet-maps/LeafletMapsPage.vue')); }); };

// // User Info
// const User = resolve => { require.ensure(['../layouts/User.vue'], ()=>{ resolve(require('../layouts/User.vue')); }); };

//Pages
const Login = resolve => { require.ensure(['../pages/login/Login.vue'], ()=>{ resolve(require('../pages/login/Login.vue')); }); };
const Register = resolve => { require.ensure(['../pages/register/Register.vue'], ()=>{ resolve(require('../pages/register/Register.vue')); }); };
// Shared pages
const Inicio = resolve => { require.ensure(['../pages/shared/Inicio.vue'], ()=>{ resolve(require('../pages/shared/Inicio.vue')); }); };
const RegistroInspirador = resolve => { require.ensure(['../pages/shared/RegistrarInspirador.vue'], ()=>{ resolve(require('../pages/shared/RegistrarInspirador.vue')); }); };
const RestorePass = resolve => { require.ensure(['../pages/shared/RecuperarClave.vue'], () => { resolve( require('../pages/shared/RecuperarClave.vue') ) }); };
const MesaAyuda = resolve => { require.ensure(['../pages/shared/MesaAyuda.vue'], () => { resolve( require('../pages/shared/MesaAyuda.vue') ) }); };
const Page404 = resolve => { require.ensure(['../pages/shared/Page404.vue'], ()=>{ resolve(require('../pages/shared/Page404.vue')); }); };
const Page500 = resolve => { require.ensure(['../pages/shared/Page500.vue'], ()=>{ resolve(require('../pages/shared/Page500.vue')); }); };


export default [

    {   path : '/', name: 'dashboard', component: Dashboard },

    { path: '/pub/inicio', name: 'inicio', component: Inicio },
    { path: '/pub/registroInspirador', name: 'registroInspirador', component: RegistroInspirador },
    { path: '/pub/recuperarClave', name: 'restorePassword', component: RestorePass },
    { path: '/shared/mesaAyuda', name: 'mesaAyuda', component: MesaAyuda },
    { path: '/reportes/inspirados', name: 'reportes-inspirados', component: ReportesInspirados },
    { path: '/reportes/inspiradores', name: 'reportes-inspiradores', component: ReportesInspiradores},
    // { path: '/reportes/sabana', name: 'reportes-sabana', component: ReportesSabana },
    { path: '/reportes/minTic', name: 'reportes-minTic', component: ReportesMinTic },
    { path: '/inspiradores', name: 'inspiradores', component: Inspiradores },
    { 
        path: '/inspiradores/ver/:id',
        name: 'ver-inspirador',
        component: VerInspirador,
        children: [
            {
                path: 'inspirados',
                component: Inspirados,
                name: 'inspirador-ver-inspirados'
            },
        ]
    },
    { path: '/admin', name: 'admin-inspiradores', component: AdminInspiradores},
    { path: '/admin/subirCSV', name: 'subir-csv', component: UploadCSVMoodle },
    { path: '/admin/subirCSVCargue', name: 'subir-csv-cargue', component: UploadCSVCargue },
    { path: '/documentos', name: 'documentos', component: Documentos },
    { path: '/documentos/subir', name: 'subir-documento', component: SubirDocumento },
    // { path: '/inspiradores/crear', name: 'crear-inspirador', component: CrearInspirador },
    { path: '/inspiradores/editar/:id', name: 'editar-inspirador', component: EditarInspirador },
    { path: '/inspirados', name: 'inspirados', component: Inspirados },
    { path: '/inspirados/crear', name: 'crear-inspirados', component: CrearInspirado },
    { path: '/inspirados/ver/:id', name: 'ver-inspirado', component: VerInspirado },
    { path: '/inspirados/editar/:id', name: 'editar-inspirado', component: EditarInspirado },
    { path: '/inspirados/historias/crear/:id', name: 'crear-historia', component: CrearHistoria },

    {
        path : '/components/maps',
        name: 'Maps',
        component: { render (c) { return c('router-view') }},
        children:[
            {
                path: '/components/maps/google-maps',
                component: GoogleMapsPage,
                name: 'google-maps-page'
            },
            {
                path: '/components/maps/leaflet-maps',
                component: LeafletMapsPage,
                name: 'leaflet-maps-page'
            }
        ]
    },
    {
        path : '/components/auth',
        name: 'auth',
        component: { render (c) { return c('router-view') }},
        children:[
            {
                path: '/auth/login',
                component: Login,
                name: 'login',
                meta: {
                    default: false,
                    title: 'Login'
                }
            },
            {
                path: '/auth/register',
                component: Register,
                name: 'Register'
            },
            {
                path: '/auth/Page404',
                component: Page404,
                name: 'Page404'
            },
            {
                path: '/auth/Page500',
                component: Page500,
                name: 'Page500'
            }

        ]
    },

    //Redirect to Home
    { path: '/redirect-me', redirect: { name: 'dashboard' } },

    // 404 redirect to home
    { path: '*', redirect: { name: 'Page404', component: Page404 }  }
];